module.exports = __webpack_public_path__ + "img/charging-hub-suggestion-private.2189846e.png";